import basicRequest from "../../../../core/redux/actions/request";

const PREFIX = "MANAGER_STAT_EVOLUTION";
const getState = (state) => state.manager.stat.evolution;
const {
    getPattern,
    postPattern,
    actionGetPattern,
    secondaryGetPattern,
    secondaryPostPattern,
    reset,
    isLoading,
    isLoaded,
    getError,
    getData,

    secondaryReset: formReset,

    getSecondarySuccess: getFormSuccess,
    getSecondaryError: getFormError,
} = basicRequest(PREFIX, getState);

export const updatePeriods = (form) => secondaryPostPattern("manager/periods/v2", form, null);

export const getVariableState = (form) => secondaryPostPattern("manager/periods/v1/variable", form, null);

export { isLoading, isLoaded, getError, getData, reset, getFormSuccess, getFormError, formReset };
